const zipCodeStates = (data) => data.zipCode;

export const zipCodeData = state => {
  const { zipCodes } = zipCodeStates(state);
  return zipCodes;
};